<template>
<div>
    <h2 v-if="subTitle" class="inrs-entete__sousTitle" v-html="subTitle"></h2>
</div>
</template>

<script>
export default {
  name: 'PageIntro',
  props: {
      view: String,
      subTitle: String,
  },
  computed: {
      title: function() {
          return this.$store.state.gpsstModule.gpsst.title;
      }
  },
  mounted() {
      const titleEl = document.getElementById('outil-page-title');
      if (titleEl) titleEl.innerHTML = this.title || '';
  },
  watch: {
      title(val) {
          const el = document.getElementById('outil-page-title');
          if (el) el.innerHTML = val || '';
      }
  }
}
</script>

<style lang="sass" scoped>
@import "../sass/_variables.sass"
@import "../sass/_media.sass"


.title
    font-family: pt_sans, Arial, "Helvetica Neue", Helvetica, sans-serif
    font-size: 2.4em
    font-weight: bold
    color: $orange-color
    margin: 0 0 0.3em 0

.chapo
    font-size: 1.15em
    font-weight: bold
    line-height: 125%
    margin-bottom: 1em
    color: $darkgray-2

// ── Toolbar (menu + version) ─────────────────────────────────────
.toolbar-block
    margin-top: 1em

    .appVersion
        margin: 0.5em 0 0 0
        color: $gray-3
        font-size: 0.9em

// ── Wrapper ──────────────────────────────────────────────────────
.intro-wrapper
    margin-left: calc(-10px)
    margin-right: calc(-10px)

</style>
